/*
 * NawkOut Micro-Interactions JavaScript
 * SOTA 2025 - Advanced interaction handlers
 */

document.addEventListener('DOMContentLoaded', function() {
  initMicroInteractions();
});

function initMicroInteractions() {
  enhanceIngredientCards();
  addMagneticEffect();
  addRippleEffect();
  addEnhancedTooltips();
  addIntersectionAnimations();
  addMouseTrackingEffect();
}

function enhanceIngredientCards() {
  const ingredientCards = document.querySelectorAll('.featured-content-column .image-grid__item');
  
  ingredientCards.forEach((card, index) => {
    card.classList.add('ingredient-card-enhanced');
    
    // Add specific ingredient classes for color variations
    const title = card.querySelector('.image-grid__title');
    if (title) {
      const ingredientName = title.textContent.toLowerCase().replace(/\s+/g, '-');
      card.classList.add(ingredientName);
    }
    
    // Enhance image containers
    const imageContainer = card.querySelector('.image-grid__img');
    if (imageContainer) {
      imageContainer.classList.add('ingredient-image');
      
      const image = imageContainer.querySelector('img');
      if (image) {
        image.classList.add('ingredient-shape-morph');
      }
    }
    
    // Enhance text elements
    const titleElement = card.querySelector('.image-grid__title');
    if (titleElement) {
      titleElement.classList.add('ingredient-title');
    }
    
    const descElement = card.querySelector('.image-grid__desc');
    if (descElement) {
      descElement.classList.add('ingredient-description');
    }
    
    // Add stagger delay for entrance animations
    card.style.setProperty('--stagger-delay', (index * 0.1) + 's');
  });
}

function addMagneticEffect() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  
  const magneticElements = document.querySelectorAll('.ingredient-card-enhanced');
  
  magneticElements.forEach(element => {
    element.addEventListener('mousemove', function(e) {
      const rect = element.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      
      const intensity = 0.1;
      const translateX = x * intensity;
      const translateY = y * intensity;
      
      element.style.transform = `translateX(${translateX}px) translateY(${translateY}px) translateZ(0)`;
    });
    
    element.addEventListener('mouseleave', function() {
      element.style.transform = 'translateX(0) translateY(0) translateZ(0)';
    });
  });
}

function addRippleEffect() {
  const rippleElements = document.querySelectorAll('.ingredient-card-enhanced');
  
  rippleElements.forEach(element => {
    element.addEventListener('click', function(e) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      
      const rect = element.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      const ripple = document.createElement('div');
      ripple.style.position = 'absolute';
      ripple.style.left = x + 'px';
      ripple.style.top = y + 'px';
      ripple.style.width = '0';
      ripple.style.height = '0';
      ripple.style.borderRadius = '50%';
      ripple.style.background = 'rgba(102, 126, 234, 0.3)';
      ripple.style.transform = 'translate(-50%, -50%)';
      ripple.style.animation = 'ripple-expand 0.6s ease-out';
      ripple.style.pointerEvents = 'none';
      
      element.appendChild(ripple);
      
      setTimeout(() => {
        if (ripple.parentNode) {
          ripple.parentNode.removeChild(ripple);
        }
      }, 600);
    });
  });
  
  // Add CSS animation for ripple
  if (!document.querySelector('#ripple-styles')) {
    const style = document.createElement('style');
    style.id = 'ripple-styles';
    style.textContent = `
      @keyframes ripple-expand {
        to {
          width: 200px;
          height: 200px;
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);
  }
}

function addEnhancedTooltips() {
  const ingredientCards = document.querySelectorAll('.ingredient-card-enhanced');
  
  ingredientCards.forEach(card => {
    const description = card.querySelector('.ingredient-description');
    const title = card.querySelector('.ingredient-title');
    
    if (description && title) {
      const tooltip = document.createElement('div');
      tooltip.classList.add('ingredient-enhanced-tooltip');
      tooltip.textContent = description.textContent;
      
      card.style.position = 'relative';
      card.appendChild(tooltip);
      
      // Enhanced hover effects
      card.addEventListener('mouseenter', function() {
        // Add benefit icons dynamically
        if (!card.querySelector('.benefit-icon')) {
          const icon = document.createElement('div');
          icon.classList.add('benefit-icon');
          
          // Set icon based on ingredient
          const ingredientName = title.textContent.toLowerCase();
          if (ingredientName.includes('ashwagandha')) icon.textContent = '🧘';
          else if (ingredientName.includes('passionflower')) icon.textContent = '🌸';
          else if (ingredientName.includes('chamomile')) icon.textContent = '🌼';
          else if (ingredientName.includes('lavender')) icon.textContent = '💜';
          else if (ingredientName.includes('lemon')) icon.textContent = '🍋';
          else if (ingredientName.includes('hops')) icon.textContent = '🌿';
          else icon.textContent = '✨';
          
          card.insertBefore(icon, title);
        }
      });
    }
  });
}

function addIntersectionAnimations() {
  if (!('IntersectionObserver' in window)) return;
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
        
        // Stagger animations for multiple cards
        const index = Array.from(entry.target.parentNode.children).indexOf(entry.target);
        setTimeout(() => {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }, index * 100);
      }
    });
  }, {
    threshold: 0.2,
    rootMargin: '0px 0px -50px 0px'
  });
  
  document.querySelectorAll('.ingredient-card-enhanced').forEach(card => {
    card.style.opacity = '0';
    card.style.transform = 'translateY(30px)';
    card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(card);
  });
}

function addMouseTrackingEffect() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  
  const cards = document.querySelectorAll('.ingredient-card-enhanced');
  
  cards.forEach(card => {
    card.addEventListener('mousemove', function(e) {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      // Create gradient that follows mouse
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      
      const deltaX = (x - centerX) / centerX;
      const deltaY = (y - centerY) / centerY;
      
      // Apply subtle rotation based on mouse position
      const rotateX = deltaY * 2;
      const rotateY = deltaX * -2;
      
      card.style.transform = `
        perspective(1000px) 
        rotateX(${rotateX}deg) 
        rotateY(${rotateY}deg) 
        translateZ(0)
      `;
      
      // Update CSS custom property for dynamic gradient
      card.style.setProperty('--mouse-x', (x / rect.width) * 100 + '%');
      card.style.setProperty('--mouse-y', (y / rect.height) * 100 + '%');
    });
    
    card.addEventListener('mouseleave', function() {
      card.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) translateZ(0)';
    });
  });
}

// Enhanced button interactions
function enhanceButtons() {
  const buttons = document.querySelectorAll('.btn, .button, .hero-button');
  
  buttons.forEach(button => {
    button.classList.add('enhanced-button');
    
    // Add click wave effect
    button.addEventListener('click', function(e) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      
      const wave = document.createElement('span');
      const rect = button.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      const x = e.clientX - rect.left - size / 2;
      const y = e.clientY - rect.top - size / 2;
      
      wave.style.cssText = `
        position: absolute;
        width: ${size}px;
        height: ${size}px;
        left: ${x}px;
        top: ${y}px;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 50%;
        transform: scale(0);
        animation: button-wave 0.6s ease-out;
        pointer-events: none;
      `;
      
      button.appendChild(wave);
      
      setTimeout(() => {
        if (wave.parentNode) {
          wave.parentNode.removeChild(wave);
        }
      }, 600);
    });
  });
  
  // Add button wave animation
  if (!document.querySelector('#button-wave-styles')) {
    const style = document.createElement('style');
    style.id = 'button-wave-styles';
    style.textContent = `
      @keyframes button-wave {
        to {
          transform: scale(4);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);
  }
}

// Performance optimizations
function optimizePerformance() {
  // Use passive event listeners where possible
  const passiveOptions = { passive: true };
  
  // Throttle resize events
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      // Recalculate positions if needed
      initMicroInteractions();
    }, 250);
  }, passiveOptions);
  
  // Use requestAnimationFrame for smooth animations
  let ticking = false;
  
  function updateAnimations() {
    // Update any continuous animations here
    ticking = false;
  }
  
  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(updateAnimations);
      ticking = true;
    }
  }
}

// Initialize enhanced buttons and performance optimizations
document.addEventListener('DOMContentLoaded', function() {
  enhanceButtons();
  optimizePerformance();
});

// Add CSS custom properties for dynamic theming
document.documentElement.style.setProperty('--interaction-primary', '#667eea');
document.documentElement.style.setProperty('--interaction-secondary', '#764ba2');
document.documentElement.style.setProperty('--interaction-success', '#2ecc71');
document.documentElement.style.setProperty('--interaction-warning', '#f1c40f');

// Export functions for potential external use
window.NawkOutInteractions = {
  init: initMicroInteractions,
  enhanceCard: enhanceIngredientCards,
  addMagnetic: addMagneticEffect,
  addRipple: addRippleEffect
};